import { SortObject } from "../@types/sortObject";

export const sortOptions: SortObject[] = [
  {
    option: "Recientes primero",
    value: "createdAt DESC",
  },
  {
    option: "Ultimos primero",
    value: "createdAt ASC",
  },
];
